import api from "./api";

export default class PrivacyApi {
  static async get() {
    return await api.get(`privacy/1`);
  }
}
